import { queryOptions } from "@tanstack/react-query";
import { backendService } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";

type PerfectDaySceneStatusFilter = "REFLECTION" | "IMAGE_GENERATION" | "COMPLETED";

export const queryOptions_perfectDayScenes = (filter?: PerfectDaySceneStatusFilter) =>
	queryOptions({
		queryKey: ["perfectDay", "scenes", filter] as const,
		queryFn: async (context) =>
			extractionWrapper(
				backendService.perfectDay.perfectDayControllerGetScenesByUser(
					context.queryKey[2] ? { chatStatus: context.queryKey[2] } : undefined,
					{
						signal: context.signal,
					},
				),
			),
	});
